"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSQNumeric = exports.PSQShortText = exports.PSQTitleInstructions = exports.PSQDate = exports.PSQFreeFormEssay = exports.PSQMultiChoiceMultiAnswer = exports.PSQMultiChoiceSingleAnswer = exports.LayoutControlsPanel = exports.ApplicationWorkflowPSQAction = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSF_1 = require("./ViewSF");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var PSQMultiChoiceSingleAnswer_1 = require("../PSQMultiChoiceSingleAnswer/PSQMultiChoiceSingleAnswer");
Object.defineProperty(exports, "PSQMultiChoiceSingleAnswer", { enumerable: true, get: function () { return PSQMultiChoiceSingleAnswer_1.PSQMultiChoiceSingleAnswer; } });
var PSQMultiChoiceMultiAnswer_1 = require("../PSQMultiChoiceMultiAnswer/PSQMultiChoiceMultiAnswer");
Object.defineProperty(exports, "PSQMultiChoiceMultiAnswer", { enumerable: true, get: function () { return PSQMultiChoiceMultiAnswer_1.PSQMultiChoiceMultiAnswer; } });
var PSQFreeFormEssay_1 = require("../PSQFreeFormEssay/PSQFreeFormEssay");
Object.defineProperty(exports, "PSQFreeFormEssay", { enumerable: true, get: function () { return PSQFreeFormEssay_1.PSQFreeFormEssay; } });
var PSQDate_1 = require("../PSQDate/PSQDate");
Object.defineProperty(exports, "PSQDate", { enumerable: true, get: function () { return PSQDate_1.PSQDate; } });
var PSQTitleInstructions_1 = require("../PSQTitleInstructions/PSQTitleInstructions");
Object.defineProperty(exports, "PSQTitleInstructions", { enumerable: true, get: function () { return PSQTitleInstructions_1.PSQTitleInstructions; } });
var PSQShortText_1 = require("../PSQShortText/PSQShortText");
Object.defineProperty(exports, "PSQShortText", { enumerable: true, get: function () { return PSQShortText_1.PSQShortText; } });
var PSQNumeric_1 = require("../PSQNumeric/PSQNumeric");
Object.defineProperty(exports, "PSQNumeric", { enumerable: true, get: function () { return PSQNumeric_1.PSQNumeric; } });
var ApplicationWorkflowPSQAction = (function (_super) {
    __extends(ApplicationWorkflowPSQAction, _super);
    function ApplicationWorkflowPSQAction(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSF = ViewSF_1.viewSF.apply(_this);
        _this.viewSF.constructor && _this.viewSF.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowPSQAction.prototype.componentDidMount = function () {
        this.viewSF.mounted && this.viewSF.mounted.apply(this, arguments);
    };
    ApplicationWorkflowPSQAction.prototype.componentWillReceiveProps = function (nextProps) {
        this.viewSF.willReceiveProps && this.viewSF.willReceiveProps.apply(this, arguments);
    };
    ApplicationWorkflowPSQAction.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSF.shouldUpdate)
            return this.viewSF.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationWorkflowPSQAction.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSF.didUpdate && this.viewSF.didUpdate.apply(this, arguments);
    };
    ApplicationWorkflowPSQAction.prototype.componentWillUnmount = function () {
        this.viewSF.unmount && this.viewSF.unmount.apply(this, arguments);
    };
    ApplicationWorkflowPSQAction.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowPSQAction.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowPSQAction.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSF.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSF.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowPSQAction.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            var question_handler = function () {
                var question_result = (_this.state.hasOwnProperty('actionItem') ? _this.state.actionItem : _this.props.actionItem).section.questions.map(function (question, question$index) {
                    var keyPrefix = (_this.state.hasOwnProperty('actionItem') ? _this.state.actionItem : _this.props.actionItem).section.workflowSectionId;
                    return [
                        React.createElement(PlayerVisible, { key: keyPrefix + '_' + question$index.toString() + 0, visible: (_this.state.hasOwnProperty('getQuestionVisibility') ? _this.state.getQuestionVisibility : _this.props.getQuestionVisibility)(question.questionId), children: [
                                React.createElement(Panel_1.Panel, { key: keyPrefix + '_' + question$index.toString() + 0, paddingTop: "Medium", paddingBottom: "Medium", children: [
                                        React.createElement(PlayerSwitch, { key: keyPrefix + '_' + question$index.toString() + 0, value: question.type, YesNo: [
                                                React.createElement(PSQMultiChoiceSingleAnswer_1.PSQMultiChoiceSingleAnswer, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("yesNoChanged", question, question$index, "repeaterArgs") })
                                            ], TrueFalse: [
                                                React.createElement(PSQMultiChoiceSingleAnswer_1.PSQMultiChoiceSingleAnswer, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("trueFalseChanged", question, question$index, "repeaterArgs") })
                                            ], MultipleChoiceSingleAnswer: [
                                                React.createElement(PSQMultiChoiceSingleAnswer_1.PSQMultiChoiceSingleAnswer, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("multiChoiceSingleAnswerChanged", question, question$index, "repeaterArgs") })
                                            ], MultipleChoiceMultipleAnswer: [
                                                React.createElement(PSQMultiChoiceMultiAnswer_1.PSQMultiChoiceMultiAnswer, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("multiChoiceMultiAnswerChanged", question, question$index, "repeaterArgs") })
                                            ], FreeFormEssay: [
                                                React.createElement(PSQFreeFormEssay_1.PSQFreeFormEssay, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("freeFormEssayChanged", question, question$index, "repeaterArgs") })
                                            ], Date: [
                                                React.createElement(PSQDate_1.PSQDate, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("dateChanged", question, question$index, "repeaterArgs") })
                                            ], TitleInstructions: [
                                                React.createElement(PSQTitleInstructions_1.PSQTitleInstructions, { key: keyPrefix + '_' + question$index.toString() + 0, question: question })
                                            ], ShortText: [
                                                React.createElement(PSQShortText_1.PSQShortText, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("shortTextChanged", question, question$index, "repeaterArgs") })
                                            ], NumericValue: [
                                                React.createElement(PSQNumeric_1.PSQNumeric, { key: keyPrefix + '_' + question$index.toString() + 0, question: question, errorMessage: question.errorMessage, onChange: _this._proxyEvent("numericChanged", question, question$index, "repeaterArgs") })
                                            ] })
                                    ] })
                            ] })
                    ];
                });
                return question_result;
            };
            return [
                React.createElement(Panel_1.Panel, { key: 0, paddingTop: "Medium", paddingBottom: "Medium", children: [
                        question_handler()
                    ] })
            ];
        };
        return root_handler();
    };
    ApplicationWorkflowPSQAction.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSF-applicationworkflowpsqaction" }, this._renderView()));
    };
    ApplicationWorkflowPSQAction.defaultProps = {
        actionItem: null,
        onDataChanged: function () { }
    };
    return ApplicationWorkflowPSQAction;
}(React.Component));
exports.ApplicationWorkflowPSQAction = ApplicationWorkflowPSQAction;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowPSQAction"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowPSQAction/ApplicationWorkflowPSQAction.js
// module id = 595
// module chunks = 0